// WarehouseNewAssortmentRuleUpdateContainer.js
import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import debounce from 'lodash/debounce';
import brandicon from "../../../../assests/brandicon.svg";
import mvidicon from "../../../../assests/mvidicon.svg";
import offerpriceicon from "../../../../assests/offerpriceicon.svg";
import producticon from "../../../../assests/producticon.svg";
import varianticon from "../../../../assests/varianticon.svg";
import { format } from 'date-fns';
import { useNavigate, useParams } from "react-router-dom";
import WarehouseRuleUpdateComponent from "./component";

const WarehouseRuleUpdateContainer = (props) => {
  const navigate = useNavigate();
  const { reference_id, ruleId } = useParams();

  const [formData, setFormData] = useState({
    startDate: new Date(),
    ruleType: "",
    names: [],
    slotCount: 1,
    validationType: "RESTRICTED",
    maxPrice: "",
    referenceId: ""
  });

  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [errors, setErrors] = useState({
    ruleType: false,
    names: false,
    maxPrice: false,
    validationType: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [newRuleId, setNewRuleId] = useState(null);
  const [newWarehouseName, setNewWarehouseName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchRuleId, setFetchRuleId] = useState();
  const [fetchRuleWarehouse, setFetchRuleWarehouse] = useState();
  const [filteredMvList, setFilteredMvList] = useState([]);
  const [showMvIdDropdown, setShowMvIdDropdown] = useState(false);
  const [getReference_rule, setGetReference_rule] = useState(null)

  // Map API rule types to UI values
  const ruleTypeMap = {
    "BRAND": "Brand",
    "VARIANT": "Variant",
    "PRODUCT": "Product",
    "MANUFACTURER_VARIANT": "MVID",
    "OFFER_PRICE": "OfferPrice"
  };

  
  const uiToApiRuleTypeMap = {
    "Brand": "BRAND",
    "Variant": "VARIANT",
    "Product": "PRODUCT",
    "MVID": "MANUFACTURER_VARIANT",
    "OfferPrice": "OFFER_PRICE"
  };

  // Map API condition types to UI values
  const conditionTypeMap = {
    "QUANTITY": "QUANTITY",
    "RESTRICTED": "RESTRICTED"
  };

  // Fetch rule details when component mounts
  useEffect(() => {
    fetchRuleDetails();
  }, []);

  const fetchRuleDetails = useCallback(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/${ruleId}`,
      "GET",
      undefined,
      async (response) => {
        if (response) {
          const ruleType = ruleTypeMap[response.rule_type] || "";
          let names = [];
          
          if (response.rule_type_details && response.rule_type_details.length > 0) {
            names = response.rule_type_details.map(item => ({
              id: item.ruleTypeId,
              name: item.ruleTypeName
            }));
          } else if (response.rule_type_id && response.rule_type_id.length > 0 && ruleType !== "OfferPrice") {
            try {
              names = await fetchNamesForIds(response.rule_type_id, ruleType);
            } catch (error) {
              console.error("Error fetching names:", error);
              names = response.rule_type_id.map(id => ({ id, name: `ID: ${id}` }));
            }
          }

          setFormData({
            startDate: new Date(response.start_date),
            ruleType,
            names,
            slotCount: response.value || 1,
            validationType: conditionTypeMap[response.condition] || "RESTRICTED",
            maxPrice: response.max_price ? response.max_price.toString() : "",
            referenceId: response.reference_id,
            referenceType: response.type || "COHORT"
          });
        }
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching rule details:", err);
        toastr.error("Error", "Failed to fetch rule details");
        setLoading(false);
      }
    );
  }, [ruleId]);

  const fetchNamesForIds = async (ids, ruleType) => {
    try {
      if (!ids || ids.length === 0) return [];

      // For MVID, use the specific API
      if (ruleType === "MVID") {
        const joinedValues = ids.join(",");
        const url = `/dashboard/api/v2/admin/mvs/all?limit=${ids.length}&offset=0&isActive=1&ids=${joinedValues}`;
        
        const response = await new Promise((resolve, reject) => {
          props.getDataFromAPI(url, "GET", undefined, resolve, reject);
        });

        const dataList = response?.list || [];
        
        return ids.map(id => {
          const item = dataList.find(i => i.id === id);
          return item 
            ? { id: item.id, name: item.variant_name || `ID: ${id}` }
            : { id, name: `ID: ${id}` };
        });
      }
      
      // For other types, use the search API
      let paramName = "";
      let responseKey = "";
      let idKey = "";
      let nameKey = "";

      switch (ruleType) {
        case "Brand":
          paramName = "brandName";
          responseKey = "brandResponse";
          idKey = "brandId";
          nameKey = "brandName";
          break;
        case "Product":
          paramName = "productName";
          responseKey = "productResponse";
          idKey = "productId";
          nameKey = "productName";
          break;
        case "Variant":
          paramName = "variantName";
          responseKey = "variantResponse";
          idKey = "variantId";
          nameKey = "variantName";
          break;
        default:
          return ids.map(id => ({ id, name: `ID: ${id}` }));
      }

      const joinedValues = ids.join(",");
      const url = `/partner/api/v2/productSearch/variant?${paramName}=${joinedValues}&offset=0&limit=${ids.length}`;

      const response = await new Promise((resolve, reject) => {
        props.getDataFromAPI(url, "GET", undefined, resolve, reject);
      });

      const dataList = response?.[responseKey] || [];

      return ids.map(id => {
        const item = dataList.find(i => i[idKey] === id);
        return item 
          ? { id: item[idKey], name: item[nameKey] }
          : { id, name: `ID: ${id}` };
      });
    } catch (err) {
      console.error("Error in fetchNamesForIds:", err);
      return ids.map(id => ({ id, name: `ID: ${id}` }));
    }
  };

  const validateForm = () => {
    const newErrors = {
      ruleType: !formData.ruleType,
      names: formData.ruleType !== "OfferPrice" && formData.names.length === 0,
      maxPrice: formData.ruleType === "OfferPrice" && !formData.maxPrice,
      validationType: formData.ruleType !== "OfferPrice" && !formData.validationType
    };
    setErrors(newErrors);
    return !Object.values(newErrors).some(error => error);
  };

  const validateInput = (value) => {
    return /^[a-zA-Z0-9\s]*$/.test(value);
  };

  const validateNumericInput = (value) => {
    return /^[0-9]*\.?[0-9]*$/.test(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "maxPrice") {
      if (validateNumericInput(value) || value === "") {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
      return;
    }

    if (name === "referenceId") {
      if (validateInput(value) || value === "") {
        setFormData(prev => ({ ...prev, [name]: value }));
      }
      return;
    }

    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: false }));
    }

    if (name === "ruleType") {
      setFormData(prev => ({
        ...prev,
        names: [],
        maxPrice: "",
        validationType: "RESTRICTED",
        slotCount: 1
      }));
      setSearchInput("");
      setShowDropdown(false);
      setShowMvIdDropdown(false);
      setSearchResults([]);
      setFilteredMvList([]);
    }
  };

  // Search for Brand, Product, Variant
  const searchEntity = useCallback(debounce((value) => {
    if (value.length > 0 && formData.ruleType && ["Brand", "Product", "Variant"].includes(formData.ruleType)) {
      setShowDropdown(true);
      setSearchLoading(true);

      let searchParam = '';
      let entityType = '';

      switch (formData.ruleType) {
        case "Brand":
          searchParam = value;
          entityType = 'brand';
          break;
        case "Product":
          searchParam = value;
          entityType = 'product';
          break;
        case "Variant":
          searchParam = value;
          entityType = 'variant';
          break;
        default:
          break;
      }

      const apiUrl = `/partner/api/v1/assortment/item/search?search=${encodeURIComponent(searchParam)}&searchEntityName=${entityType}`;

      props.getDataFromAPI(apiUrl, "GET", undefined, (response) => {
        const data = response || {};
        let results = [];

        if (Array.isArray(data)) {
          results = data.map(item => ({
            id: item.id,
            name: item.name
          }));
        }

        setSearchResults(results);
        setSearchLoading(false);
      }, (err) => {
        console.error("Search error:", err);
        setSearchResults([]);
        setSearchLoading(false);
      });
    } else {
      setShowDropdown(false);
      setSearchResults([]);
    }
  }, 300), [formData.ruleType]);

  // Search for MVID
  const searchMvId = useCallback(debounce((value) => {
    if (value.length > 0 && formData.ruleType === "MVID") {
      setShowMvIdDropdown(true);
      setSearchLoading(true);

      props.getDataFromAPI(
        `/dashboard/api/v2/admin/mvs/all?limit=50&offset=0&isActive=1&search=${encodeURIComponent(value)}`,
        "GET",
        undefined,
        (response) => {
          const results = response?.list?.map(item => ({
            id: item.id,
            name: item.variant_name,
            displayName: `${item.id} - ${item.variant_name || 'N/A'}`
          })) || [];
          
          setFilteredMvList(results);
          setSearchLoading(false);
        },
        (err) => {
          console.error("MVID search error:", err);
          setFilteredMvList([]);
          setSearchLoading(false);
        }
      );
    } else {
      setShowMvIdDropdown(false);
      setFilteredMvList([]);
    }
  }, 300), [formData.ruleType]);

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    
    if (validateInput(value) || value === "") {
      setSearchInput(value);
      
      if (formData.ruleType === "MVID") {
        searchMvId(value);
      } else if (["Brand", "Product", "Variant"].includes(formData.ruleType)) {
        searchEntity(value);
      }
    }
  };

  const handleAddName = (item) => {
    if (!formData.names.some(existingItem => existingItem.id === item.id)) {
      setFormData(prev => ({
        ...prev,
        names: [...prev.names, { id: item.id, name: item.name }]
      }));
      setErrors(prev => ({ ...prev, names: false }));
    }
    setSearchInput("");
    setShowDropdown(false);
    setShowMvIdDropdown(false);
  };

  const handleRemoveName = (idToRemove) => {
    setFormData(prev => ({
      ...prev,
      names: prev.names.filter(item => item.id !== idToRemove)
    }));
  };

  const handleSlotCountChange = (delta) => {
    setFormData(prev => ({
      ...prev,
      slotCount: Math.max(1, prev.slotCount + delta)
    }));
  };

  const handleDateChange = (newValue) => {
    setFormData(prev => ({ ...prev, startDate: newValue }));
  };

  const handleUpdateRule = () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    const payload = {
      type: "WAREHOUSE",
      reference_id: formData.referenceId,
      start_date: format(formData.startDate, 'yyyy-MM-dd'),
      rule_type: uiToApiRuleTypeMap[formData.ruleType],
      condition: formData.validationType,
      value: formData.slotCount,
      max_price: formData.ruleType === "OfferPrice" ? parseFloat(formData.maxPrice) : null,
      rule_type_id: formData.ruleType === "OfferPrice" ? [0] : formData.names.map(item => item.id)
    };

    props.getDataFromAPI(
      `/partner/api/v1/assortment/rule/${ruleId}/update`,
      "PUT",
      payload,
      (response) => {
        const failures = response.rule_failures;
        
              if (failures) {
                // ✅ toaster me failure show
                toastr.warning("", failures);
              } else {
                // ✅ toaster me success show
                toastr.success("Rule created successfully!");
              }
        setIsSubmitting(false);
        toastr.success("Rule updated successfully!");
        setNewRuleId(response.id);
        setShowSuccessModal(true);
        setFetchRuleId(response.id);
        setNewWarehouseName(response.reference_name);
        setFetchRuleWarehouse(response.reference_name);
        setGetReference_rule(response.rule_failures)
      },
      (err) => {
        setIsSubmitting(false);
        toastr.error("Error", err.message);
        console.error("Rule update error:", err);
      }
    );
  };
console.log("getrule", getReference_rule)
  return (
    <WarehouseRuleUpdateComponent
      formData={formData}
      searchInput={searchInput}
      searchResults={formData.ruleType === "MVID" ? filteredMvList : searchResults}
      searchLoading={searchLoading}
      showDropdown={formData.ruleType === "MVID" ? showMvIdDropdown : showDropdown}
      errors={errors}
      isSubmitting={isSubmitting}
      loading={loading}
      ruleTypes={[
        { value: "Brand", label: "Brand", icon: brandicon },
        { value: "Variant", label: "Variant", icon: varianticon },
        { value: "Product", label: "Product", icon: producticon },
        { value: "MVID", label: "MVID", icon: mvidicon },
        { value: "OfferPrice", label: "Offer Price", icon: offerpriceicon }
      ]}
      onChange={handleChange}
      onSearchInputChange={handleSearchInputChange}
      onAddName={handleAddName}
      onRemoveName={handleRemoveName}
      onSlotCountChange={handleSlotCountChange}
      onSubmit={handleUpdateRule}
      onDateChange={handleDateChange}
      showSuccessModal={showSuccessModal}
      newRuleId={newRuleId}
      setShowSuccessModal={setShowSuccessModal}
      newWarehouseName={newWarehouseName}
      fetchRuleId={fetchRuleId}
      fetchRuleWarehouse={fetchRuleWarehouse}
      isMvidSearch={formData.ruleType === "MVID"}
    />
  );
};

function mapStateToProps(props) {
  return { props };
}

export default connect(mapStateToProps, { getDataFromAPI })(WarehouseRuleUpdateContainer);